import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpEvent, HttpHandler, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';

@Injectable()
export class AuthInterceptorService implements HttpInterceptor {
    constructor(
        private authService: AuthService,
      ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        let token = this.authService.token;
        if(req.url.indexOf('api/v') === 0 && token){
            let modifiedRequest;
            modifiedRequest = req.clone(
                {
                    headers: req.headers.append('authorization', 'Bearer '+token)
                });
            return next.handle(modifiedRequest);
        }
        return next.handle(req);
    }
}
